import React, { useState, useEffect } from "react";
import Sidebar from "../sidebar";
import "./company.css";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import EastIcon from "@mui/icons-material/East";
import { api } from "../../../utils/api";
import {
  Button,
  TextField,
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  Autocomplete,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import SkipQuestionare from "../../Common/SkipQuestionare";
import InitialQuestionareSidebar from "../../../Layout/InitialQuestionareSidebar";
import { getQuestionareSubmitted } from "../../../utils/storage";

// import { companyId } from "../../../utils/companyId";

const Company = () => {
  const companyDetails = getQuestionareSubmitted();

  const navigate = useNavigate();
  const companyInfo = [
    // "Select",
    "0-50",
    "50-100",
    "100-500",
    "500-1000",
    "1000-5000",
    "5000-10000",
  ];
  const companyIndustry = [
    "Select",
    "Advertising & Marketing",
    "Aerospace & Défense",
    "Agricultural Products",
    "Alcoholic Beverages",
    "Air Freight & Logistics",
    "Apparel, Accessories & Footwear",
    "Appliance Manufacturing",
    "Asset Management & Custody Activities",
    "Auto Parts",
    "Automobiles",
    "Biofuels",
    "Biotechnology & Pharmaceuticals",
    "Building Products & Furnishings",
    "Car Rental & Leasing",
    "Casinos & Gaming",
    "Chemicals",
    "Coal Operations",
    "Commercial Banks",
    "Construction Materials",
    "Consumer Finance",
    "Containers & Packaging",
    "Cruise Lines",
    "Drug Retailers",
    "E-Commerce",
    "Education",
    "Electric Utilities & Power Generators",
    "Electronic Manufacturing Services & Original Design Manufacturing",
    "Electrical & Electronic Equipment",
    "Engineering & Construction Services",
    "Food Retailers & Distributors",
    "Forestry Management",
    "Fuel Cells & Industrial Batteries",
    "Gas Utilities & Distributors",
    "Hardware",
    "Health Care Delivery",
    "Healthcare Distributors",
    "Home Builders",
    "Hotels & Lodging",
    "Household & Personal Products",
    "Industrial Machinery & Goods",
    "Insurance",
    "Internet Media & Services",
    "Investment Banking & Brokerage",
    "Iron & Steel Producers",
    "Leisure Facilities",
    "Managed Care",
    "Marine Transportation",
    "Media & Entertainment",
    "Meat, Poultry & Dairy",
    "Medical Equipment & Supplies",
    "Metals & Mining",
    "Mortgage Financing",
    "Multiline and Specialty Retailers & Distributors",
    "Non-Alcoholic Beverages",
    "Oil & Gas - Exploration & Production",
    "Oil & Gas - Midstream",
    "Oil & Gas - Refining & Marketing",
    "Oil & Gas - Services",
    "Pulp & Paper Products",
    "Professional & Commercial Services",
    "Processed Foods",
    "Rail Transportation",
    "Real Estate",
    "Restaurants",
    "Road Transportation",
    "Security & Commodity Exchanges",
    "Semiconductors",
    "Software & IT Services",
    "Solar Technology & Project Developers",
    "Telecommunication Services",
    "Tobacco",
    "Toys & Sporting Goods",
    "Waste Management",
    "Water Utilities & Services",
    "Wind Technology & Project Developers",
  ];

  const [companyName, setCompanyName] = useState("");
  const [industry, setIndustry] = useState(companyIndustry[0]);
  const [numberOfEmployees, setNumberOfEmployees] = useState("");
  const [headquarters, setHeadquarters] = useState("");
  const [additionalLocations, setAdditionalLocations] = useState([]);
  const [showAddButton, setShowAddButton] = useState(false);
  const [showInputField, setShowInputField] = useState(false);
  const [newLocation, setNewLocation] = useState("");
  const [isExist, setIsExist] = useState(false);
  const [errors, setErrors] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [locationSelect, setLocationSelect] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const companyId = localStorage.getItem("companyId");
      try {
        const response = await axios.get(
          `${api}/company/companies/${companyId}`
        );
        // Update state only if data is available
        if (response.data) {
          setCompanyName(response.data.companyName || "");
          setIndustry(response.data.industry || "");
          setNumberOfEmployees(response.data.numberOfEmployees || "");
          setHeadquarters(response.data.headquarters || "");
          setAdditionalLocations(response.data.additionalLocations || "");
          setIsExist(true); // Set existence flag
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleOpenDialog = (index) => {
    setDeleteIndex(index);
    setOpenDialog(true);
  };

  const handleCancelDelete = () => {
    setOpenDialog(false);
    setDeleteIndex(null);
  };

  const handleConfirmDelete = () => {
    if (deleteIndex !== null) {
      handleDeleteLocation(deleteIndex);
    }
    setOpenDialog(false);
  };

  const handleAddClick = () => {
    setShowInputField(true);
    setErrors((prev) => ({ ...prev, newLocation: "", locationSelects: "" })); // Clear error when adding a new location
  };
  console.log("errors", errors);
  const handleNewLocationChange = (event) => {
    setNewLocation(event.target.value);
    setErrors((prev) => ({ ...prev, newLocation: "" })); // Clear error on change
  };

  const handleSaveNewLocation = () => {
    if (newLocation.trim() === "") {
      setErrors((prev) => ({ ...prev, newLocation: "This field is required" }));
      return;
    }

    const newLocationLower = newLocation.trim().toLowerCase(); // Use lowercase only for validation

    // Validate that the new location is not the same as headquarters
    if (newLocationLower === headquarters.trim().toLowerCase()) {
      setErrors((prev) => ({
        ...prev,
        newLocation: "Additional location cannot be the same as headquarters",
      }));
      return;
    }

    // Validate that the new location is not already in additional locations
    if (
      additionalLocations
        .map((loc) => loc.toLowerCase())
        .includes(newLocationLower)
    ) {
      setErrors((prev) => ({
        ...prev,
        newLocation: "This location already exists in the additional locations",
      }));
      return;
    }

    // Keep the original case of the newLocation when adding to additional locations
    setAdditionalLocations([...additionalLocations, newLocation.trim()]);

    setNewLocation(""); // Clear the input after saving
    setShowInputField(false); // Hide the input field after saving
    setLocationSelect(""); // Reset the select input
    setShowAddButton(false);
  };

  const handleDeleteNewLocation = () => {
    setNewLocation(""); // Clears the input field
    setShowInputField(false); // Hides the input field
  };

  const handleDeleteLocation = (index) => {
    const updatedLocations = additionalLocations.filter((_, i) => i !== index);
    setAdditionalLocations(updatedLocations);
    setDeleteIndex(null); // Reset delete index
  };

  const validateFields = () => {
    const newErrors = {};
    if (companyName.trim() === "")
      newErrors.companyName = "This field is required";
    if (industry === "") newErrors.industry = "Please select at least one";
    // if (numberOfEmployees === "")
    //   newErrors.numberOfEmployees = "Please select at least one";
    // if (headquarters.trim() === "")
    //   newErrors.headquarters = "This field is required";

    if (
      additionalLocations.some(
        (location) =>
          location.trim().toLowerCase() === headquarters.trim().toLowerCase()
      )
    ) {
      newErrors.additionalLocations =
        "One or more additional locations are the same as headquarters";
    }

    if (showInputField && newLocation.trim() === "") {
      newErrors.newLocation = "This field is required";
    } else if (
      newLocation.trim() !== "" &&
      additionalLocations.includes(newLocation.trim())
    ) {
      newErrors.newLocation =
        "This location already exists in the additional locations";
    }

    if (locationSelect === "Yes" && newLocation.trim() === "") {
      newErrors.locationSelects = "Need to add location";
    } else if (
      newLocation.trim() !== "" &&
      !additionalLocations.includes(newLocation)
    ) {
      newErrors.newLocation = "Please save the location before submission";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    setLocationSelect(selectedValue); // Update the selected value
    setShowAddButton(selectedValue === "Yes"); // Show or hide "Add" button
    setErrors((prev) => ({
      ...prev,
      locationSelects: "",
    }));
  };

  const Save = async () => {
    if (validateFields()) {
      try {
        const payload = {
          companyName,
          industry,
          numberOfEmployees,
          headquarters,
          additionalLocations,
        };
        payload.company_information = false;
        // Create a copy of payload excluding 'additionalLocations'
        const checkFields = { ...payload };
        delete checkFields.additionalLocations;

        // Now check if all values are filled (non-empty strings or values)
        const allFieldsFilled = Object.values(checkFields).every(
          (val) => val !== undefined && val !== null && val !== ""
        );

        // If all required fields are filled, add the flag
        if (allFieldsFilled) {
          payload.company_information = true;
        }

        let response;
        if (!isExist) {
          response = await axios.post(`${api}/company/companies`, payload);
          const newCompanyId = response.data._id;
          localStorage.setItem("companyId", newCompanyId);
        } else {
          const companyId = localStorage.getItem("companyId");
          response = await axios.put(
            `${api}/company/companies/${companyId}`,
            payload
          );
        }
        localStorage.setItem("companyInfo", JSON.stringify(payload));
        navigate(
          companyDetails?.questionareSubmitted ? "/preview" : "/sustainability"
        );
      } catch (error) {
        // Detect duplicate key error and set a friendly message
        if (error.response?.data?.message?.includes("E11000")) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            apiError: "Company name already exists",
          }));
        } else {
          const errorMessage =
            error.response?.data?.message || "Please fill the data";
          setErrors((prevErrors) => ({
            ...prevErrors,
            apiError: errorMessage,
          }));
        }
      }
    }
  };

  const fetchCities = async (query) => {
    try {
      setLoading(true);
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${query}&addressdetails=1&limit=5`
      );
      const data = await response.json();
      const names = data.map((item) => item.name);
      setOptions(names);
      setLoading(false);
    } catch (error) {
      setErrors({ headquarters: "Error fetching cities. Please try again." });
      setLoading(false);
    }
  };

  const handleInputChange = (event, newInputValue) => {
    setHeadquarters(newInputValue);
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const newTimeout = setTimeout(() => {
      if (newInputValue) {
        fetchCities(newInputValue);
      } else {
        setOptions([]);
      }
    }, 500);

    setDebounceTimeout(newTimeout);
  };

  const handleSelectionChange = (event, newValue) => {
    setHeadquarters(newValue || "");
    if (!newValue) {
      setErrors({ headquarters: "Please select a valid city." });
    } else {
      setErrors({ headquarters: "" });
    }
  };

  return (
    <Box>
      <Dialog open={openDialog} onClose={handleCancelDelete}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this location?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          display: "flex",
          backgroundColor: "#EDEDED",
          height: "100vh",
        }}
      >
        <Box
          sx={{
            width: "25vw",
            // overflowY: "auto",
            // border: "2px solid green",
            // height: "100vh",
          }}
        >
          <InitialQuestionareSidebar />
        </Box>
        <Box
          sx={{
            p: 2,
            mt: 3,
            width: "75vw",
            height: "100vh",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "80%",
              marginBottom: "1rem",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                zIndex: 1,
                padding: "10px 0px",
                borderRadius: "4px",
                alignSelf: "flex-start",
                // ml: "5rem",
              }}
            >
              COMPANY INFORMATION
            </Typography>
            <SkipQuestionare />
          </div>

          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            className="main"
            sx={{ width: "80%" }}
          >
            <Typography
              variant="body1"
              fontWeight="bold"
              sx={{ marginTop: "10px", marginBottom: "-10px" }}
            >
              What is your company name?
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Company name"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              error={!!errors.companyName}
              // helperText={errors.companyName}
              helperText={
                <>
                  <Typography
                    color="error"
                    variant="body2"
                    sx={{ fontSize: "14px", marginLeft: "-10px" }}
                  >
                    {errors.companyName}
                  </Typography>
                  <Typography
                    color="error"
                    variant="body2"
                    sx={{ fontSize: "14px", marginLeft: "-10px" }}
                  >
                    {errors.apiError}
                  </Typography>
                </>
              }
            />

            <Typography
              variant="body1"
              fontWeight="bold"
              sx={{ marginTop: "10px", marginBottom: "-10px" }}
            >
              What industry are you in?
            </Typography>
            <FormControl fullWidth error={!!errors.industry}>
              <Select
                value={industry}
                input={<OutlinedInput />}
                displayEmpty
                onChange={(e) => setIndustry(e.target.value)}
              >
                {companyIndustry.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
              {errors.industry && (
                <Typography
                  color="error"
                  variant="body2"
                  sx={{ fontSize: "14px", marginLeft: "0px" }}
                >
                  {errors.industry}
                </Typography>
              )}
            </FormControl>

            <Typography
              variant="body1"
              fontWeight="bold"
              sx={{ marginTop: "10px", marginBottom: "-10px" }}
            >
              How many employees do you currently have?
            </Typography>
            <FormControl fullWidth error={!!errors.numberOfEmployees}>
              <Select
                input={<OutlinedInput />}
                displayEmpty
                value={numberOfEmployees}
                onChange={(e) => setNumberOfEmployees(e.target.value)}
              >
                <MenuItem value="" disabled>
                  Select
                </MenuItem>
                {companyInfo.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
              {errors.numberOfEmployees && (
                <Typography
                  color="error"
                  variant="body2"
                  sx={{ fontSize: "14px", marginLeft: "0px" }}
                >
                  {errors.numberOfEmployees}
                </Typography>
              )}
            </FormControl>

            <Typography
              variant="body1"
              fontWeight="bold"
              sx={{ marginTop: "10px", marginBottom: "-10px" }}
            >
              Where is your company headquartered?
            </Typography>
            <Autocomplete
              freeSolo
              options={options}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.label
              }
              filterOptions={(x) => x} // Disable default filtering to rely on API results
              onInputChange={handleInputChange}
              onChange={handleSelectionChange}
              inputValue={headquarters}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  variant="outlined"
                  placeholder="Search for a city"
                  error={!!errors.headquarters}
                  helperText={
                    errors.headquarters && (
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "14px", marginLeft: "-10px" }}
                      >
                        {errors.headquarters}
                      </Typography>
                    )
                  }
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />

            {additionalLocations.map((location, index) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                sx={{ width: "110%" }}
              >
                <Box flexDirection="column" sx={{ width: "91%" }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", fontSize: "14px", mb: 1 }}
                  >
                    {`Additional Location ${index + 1}`}
                  </Typography>

                  <TextField
                    fullWidth
                    variant="outlined"
                    value={location}
                    onChange={(e) => {
                      const updatedLocations = [...additionalLocations];
                      updatedLocations[index] = e.target.value;
                      setAdditionalLocations(updatedLocations);
                    }}
                    placeholder={`Location ${index + 1}`}
                  />
                </Box>
                <IconButton
                  onClick={() => handleOpenDialog(index)}
                  sx={{ mt: 4 }}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}

            <Typography
              variant="body1"
              fontWeight="bold"
              sx={{ marginTop: "10px", marginBottom: "-10px" }}
            >
              Do you have additional locations? If so, please list them.
            </Typography>
            <FormControl fullWidth>
              <Select
                input={<OutlinedInput />}
                onChange={handleSelectChange}
                displayEmpty
                value={locationSelect || ""}
              >
                <MenuItem value="" disabled>
                  Select
                </MenuItem>
                <MenuItem value="Yes">Yes</MenuItem>
                <MenuItem value="No">No</MenuItem>
              </Select>
            </FormControl>
            {errors.locationSelects && (
              <Typography
                color="error"
                variant="body2"
                sx={{ fontSize: "14px", marginLeft: "0px" }}
              >
                {errors.locationSelects}
              </Typography>
            )}
            {showAddButton && (
              <Box display="flex" justifyContent="flex-end" mt={1}>
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={handleAddClick}
                  sx={{ color: "#204769", borderColor: "#204769" }}
                >
                  Add
                </Button>
              </Box>
            )}

            {showInputField && (
              <Box
                display="flex"
                alignItems="center"
                mt={1}
                sx={{ width: "110%" }}
              >
                <Box sx={{ width: "91%" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Enter new location"
                    value={newLocation}
                    onChange={handleNewLocationChange}
                    error={!!errors.newLocation}
                    // helperText={errors.newLocation}
                    helperText={
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "14px", marginLeft: "-10px" }}
                      >
                        {errors.newLocation}
                      </Typography>
                    }
                  />
                </Box>
                <IconButton onClick={handleSaveNewLocation}>
                  <SaveIcon />
                </IconButton>
                <IconButton onClick={handleDeleteNewLocation}>
                  <DeleteIcon />
                </IconButton>
              </Box>
            )}
          </Box>

          <div
            style={{
              width: "80%",
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "2rem",
              marginTop: "0rem",
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#1C486B",
                textTransform: "none",
              }}
              onClick={Save}
            >
              Save & Continue
              <EastIcon sx={{ ml: 2 }} />
            </Button>
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default Company;
